import { render, staticRenderFns } from "./OurGettingStartedHint.vue?vue&type=template&id=61f773c2&"
import script from "./OurGettingStartedHint.vue?vue&type=script&lang=js&"
export * from "./OurGettingStartedHint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports